import { useCallback } from "react"
import { useErrorBanner } from "src/context/errorBanner/useErrorBanner"
import { useExtractErrorMessage } from "../useExtractErrorMessage/useExtractErrorMessage"

export const useErrorResponse = () => {
	const { showError } = useErrorBanner()
	const extractErrorMessage = useExtractErrorMessage()

	return useCallback(
		(error: unknown) => {
			const errorMessage = extractErrorMessage(error)
			showError(errorMessage)
		},
		[showError, extractErrorMessage],
	)
}
